// ── Notification Types ─────────────────────────────────────────────────────────

export type NotificationType =
  | 'timer_complete'        // Task timer reached expected duration
  | 'pomodoro_focus_end'    // Pomodoro focus phase completed
  | 'pomodoro_break_end'    // Pomodoro break phase completed
  | 'task_upcoming'         // Scheduled task starting soon
  | 'task_overdue'          // Task past its deadline

export type NotificationPriority = 'low' | 'medium' | 'high'

export type NotificationSoundPreference = 'standard' | 'sky' | 'dash' | 'mute'

export interface AppNotification {
  id: string
  user_id: string
  type: NotificationType
  title: string
  message: string
  priority: NotificationPriority
  read: boolean
  task_id: string | null
  deep_link?: string | null
  metadata?: Record<string, JsonValue>
  created_at: string
  read_at: string | null
}

export type JsonValue =
  | string
  | number
  | boolean
  | null
  | { [key: string]: JsonValue | undefined }
  | JsonValue[]

export interface NotificationInsert {
  user_id: string
  type: NotificationType
  title: string
  message: string
  priority: NotificationPriority
  task_id?: string | null
}

export interface NotificationPreferences {
  email_notifications: boolean
  push_enabled: boolean
  sound_preference: NotificationSoundPreference
  timer_notifications: boolean
  pomodoro_notifications: boolean
  task_reminder_notifications: boolean
}

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  email_notifications: true,
  push_enabled: true,
  sound_preference: 'standard',
  timer_notifications: true,
  pomodoro_notifications: true,
  task_reminder_notifications: true,
}

/** Map notification type → priority */
export function getNotificationPriority(type: NotificationType): NotificationPriority {
  switch (type) {
    case 'timer_complete':
    case 'pomodoro_focus_end':
      return 'high'
    case 'pomodoro_break_end':
    case 'task_upcoming':
      return 'medium'
    case 'task_overdue':
      return 'high'
  }
}
